import type { SignatureDocument } from "../../../@types/signatures";

/** The signing link of a prepared document's signer (the dashboard prepares one signer per document). */
export function signingLinkOf(document: SignatureDocument): string | undefined {
  return document.signers[0]?.signing?.publicSigningUrl;
}
